import { DefaultService } from "./DefaultService";
import axios from "@/api/axios";

export default class extends DefaultService {
  public static readonly entityUrl = "service-default-names";

  static listWithAverage(tenancyId: any = null): Promise<any> {
    let urlParams = "";
    if (tenancyId) {
      urlParams = `?tenancyId=${tenancyId}`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/with-average${urlParams}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  }

  static getByServiceName(serviceName: any = null): Promise<any> {
    let urlParams = "";
    if (serviceName) {
      urlParams = `?url_parameter=${serviceName}`;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/get-by-service-name${urlParams}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  }

  static getDisplayRule(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/display-rules`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  }
}
